import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

export const accessGuard = (route: ActivatedRouteSnapshot) => {
	const sessionService: SessionService = inject(SessionService);
	const router: Router = inject(Router);

	const hasAccess: boolean = route.data.access
		? sessionService.hasAccess(route.data.access, route.data.additions ?? [])
		: true;

	if (hasAccess) {
		return true;
	} else {
		router.getCurrentNavigation().initialUrl.queryParams = {};
		return false;
	}
}
